const t = {
  name: "ChevronRight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.58594 18.9998L14.5859 11.9998L7.58594 4.99985L9.00015 3.58564L17.4144 11.9998L9.00015 20.4141L7.58594 18.9998Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ChevronRight
};
